import { object, string, array, number, boolean } from "yup";

export default intl => {
  const requiredText = intl.formatMessage({ id: "app.form.required" });

  return object().shape({
    name: string().required(requiredText),
    description: string().required(requiredText),
    deploymentId: string().required(requiredText),
    allowedEventTypes: array()
      .of(string())
      .required(requiredText)
      .nullable(),
    liveCommentatorSupport: number().required(requiredText),
    keepVideosForMonths: number().required(requiredText),
    allowedMasterStreamSave: boolean().required(requiredText),
    monthlyTiiviiHours: number().required(requiredText),
    allowedProductionTypes: array()
      .of(string())
      .required(requiredText)
      .nullable(),
    tiiviiOttConfig: object().shape({
      enabled: boolean().required(requiredText),
      nimbleConfigUrl: string().when("enabled", {is: true, then: string().required(requiredText)}),
      webhookUrl: string().when("enabled", {is: true, then: string().required(requiredText)})
    })
  });
};
